import { Paper, styled } from '@mui/material';
import { grey } from '@mui/material/colors';
import Copyright from '../Copyright';

const FooterContainer = styled('footer')({
  height: '30px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

const Footer = () => (
  <Paper
    sx={{
      padding: 1,
      background: grey[50],
      zIndex: 100,
      position: 'absolute',
      right: 0,
      bottom: 0,
      left: 0,
      width: 'inherit',
    }}
  >
    <FooterContainer>
      <Copyright />
    </FooterContainer>
  </Paper>
);
export default Footer;
